import React from 'react';

import { CoreIcon } from '@aspid/ui';

import { getIconByMimeType } from './getIconByMimeType';

import type { FileTypeIconProperties } from './FileTypeIcon.types';

export const FileTypeIcon: React.FC<FileTypeIconProperties> = ({
  fileType,
  styles,
  sx,
}) => {
  const fileIcon = React.useMemo(
    () => getIconByMimeType(fileType || ''),
    [fileType],
  );

  return (
    <CoreIcon
      icon={fileIcon}
      style={{
        fontSize: '1rem',
        cursor: 'pointer',
        pointerEvents: 'none',
        ...styles,
      }}
      sx={sx}
    />
  );
};
